import ready from "./ready";
import activecampaign from "./activecampaign";

ready(() => {
    activecampaign()
})